module.exports = __webpack_public_path__ + "static/media/pontic.767e8edc.svg";